











































/** @format */

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EchartOption from '@/common/const/e-chart-options';
import CustomTab from './custom-tab/index.vue';
import _ from 'lodash';
import * as api from '@/api/business-overview';
import moment from 'moment';
import { commaNumber } from '../format';

@Component({
  components: { CustomTab }
})
export default class IncomeStatistics extends Vue {
  commaNumber: Function = commaNumber;

  @Prop({ default: 0 })
  type?: number;

  @Prop({ default: () => [] })
  orgIds: any[];

  @Prop()
  parkId?: String;

  timeTypeTabs: any[] = [
    {
      label: '近一周',
      value: 'week'
    },
    {
      label: '近一月',
      value: 'month'
    },
    {
      label: '近一年',
      value: 'year'
    }
  ];

  incomeType: String = 'temporary';
  timeType: number = 0;

  @Watch('parkId')
  @Watch('orgIds')
  @Watch('timeType')
  onParamChange() {
    this.init();
  }

  @Watch('incomeType')
  onTypeChange() {
    if (!this.data) {
      return;
    }
    const charData = this.data[this.incomeType + 'Trend'];
    this.seriesBarData = charData.map((i: { amount: any }) => i.amount);
    this.seriesBarData1 = this.getLabel(charData);
    this.xAxisData = charData.map((i: { date: any }) => i.date);
    this.rankData = this.getRankDataLimit(this.data[this.incomeType + 'TrendTop']);
    this.refreshChart();
  }

  options: EchartOption = new EchartOption();
  isData: boolean = true;

  xAxisData: string[] = [];
  seriesBarData: number[] = [];
  seriesBarData1: any[] = [];
  data: any = null;
  rankData: any = [];

  get title() {
    return {
      show: false
    };
  }

  get toolTip() {
    return {
      show: true,
      trigger: 'axis',
      axisPointer: {
        type: 'line'
      },
      hideDelay: 1000,
      formatter: function(params: any[], ticket: any, callback: any) {
        const data = params[0];
        return data
          ? `
          <div class="income-statistics-tooltip">
            <div class="income-statistics-tooltip-title"><span>${data.name}</span></div>
            <div class="income-statistics-tooltip-item v1">实收金额：<span>${commaNumber(
              data.value.toFixed(2)
            )}</span></div>

          </div>
        `
          : '';
      }
    };
  }

  get grid() {
    return {
      top: '8%',
      left: '5%',
      right: '5%',
      bottom: '5%',
      containLabel: true
    };
  }

  get legend() {
    return {
      show: false
    };
  }

  get xAxis() {
    return {
      type: 'category',
      boundaryGap: true,
      axisLabel: {
        color: '#000',
        formatter: (value: moment.MomentInput, index: any) => {
          if (this.timeType == 2) {
            return moment(value).format('M月');
          } else {
            return moment(value).format('M/D');
          }
        }
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      data: this.xAxisData
    };
  }

  get yAxis() {
    return [
      {
        type: 'value',
        axisLabel: {
          show: true,
          color: '#000'
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#ccc',
            type: 'dashed'
          }
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        }
      }
    ];
  }

  get series() {
    const maxValue = _.max(this.seriesBarData);
    return [
      {
        name: '实收金额',
        type: 'bar',
        barMaxWidth: 30,
        itemStyle: {
          color: '#1890ff'
        },
        // label: {
        //   show: true,
        //   position: 'top',
        //   color: '#000',
        //   formatter: params => {
        //     return commaNumber(params.value.toFixed(2))
        //   },
        // },
        data: this.seriesBarData1
      }
    ];
  }

  async fetchData() {
    const timeTypeValue = this.timeTypeTabs[this.timeType].value;
    let param;
    if (this.type == 0) {
      param = {
        type: timeTypeValue,
        orgIds: this.orgIds
      };
    } else {
      param = {
        type: timeTypeValue,
        parkId: this.parkId
      };
    }
    try {
      const { data } = await api.queryIncomeStatistics(param);
      this.data = data;
      const charData = data[this.incomeType + 'Trend'];
      this.seriesBarData = charData.map((i: { amount: any }) => i.amount);
      this.seriesBarData1 = this.getLabel(charData);
      this.xAxisData = charData.map((i: { date: any }) => i.date);
      this.rankData = this.getRankDataLimit(data[this.incomeType + 'TrendTop']);
    } catch (e) {
      console.log(e);
    } finally {
      this.refreshChart();
    }
  }

  getRankDataLimit(list: string | any[]) {
    if (list && list.length) {
      return list.slice(0, 10);
    } else {
      return [];
    }
  }
  getLabel(list: string | any[]) {
    const arr = [];
    if (list && list.length) {
      for (let i = 0; i < list.length; i++) {
        let showLabel = true;
        if (this.timeType != 1) {
          showLabel = true;
        } else {
          showLabel = i % 2 == 0 ? true : false;
        }
        arr.push({
          value: list[i].amount,
          label: {
            show: showLabel,
            position: 'top',
            color: '#000',
            formatter: (params: { value: string }) => {
              return parseInt(params.value);
              //return commaNumber(params.value.toFixed(2))
            }
          }
        });
      }
    }
    return arr;
  }
  // async fetchRankData() {
  //   const { data } = await api.queryIncomeStatisticsRank({})
  //   this.rankData = data;
  // }

  refreshChart() {
    const options: EchartOption = new EchartOption();
    options.setLegend(this.legend);
    options.setGrid(this.grid);
    options.setXAxis(this.xAxis, true);
    options.setYAxis(this.yAxis, true);
    options.setTitle(this.title);
    options.setSeries(this.series);
    options.setTooltip(this.toolTip);
    this.options = options;
  }

  init() {
    this.fetchData();
  }

  mounted() {
    this.init();
  }
}
